import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';
import { NativeAppState } from './types';

export const initialState: NativeAppState = {
  isNativeApp: false,
  isNativeAppConfigLoaded: false,
  nativeAppConfig: {
    headerVisibility: false,
    footerVisibility: false,
    popupVisibility: true,
    delegateRouting: false,
    isIos: false,
    isAndroid: false,
    type: '' // "android" || "ios"
  },
  androidLink: '',
  iosLink: '',
  visibleMobileBanner: false,
  visiblePWAInstructions: false
};

export const useNativeAppStore = createHookStore(
  STORE_NAMES.NATIVE_APP,
  initialState
);

export const useNativeAppSelector = createUseSelector(useNativeAppStore);
